import React, { useState, useMemo, useCallback } from 'react';
import { Div, Icon } from '@pinpoint/design-kit';
import get from 'lodash.get';

import Rbac from 'src/containers/rbac';
import CONSTANTS from 'src/store/constants';

import DownloadActuarialModelDialog from 'src/components/dialogs/downloadActuarialScores';

const getNameType = (type) => {
  switch (type) {
    case CONSTANTS.TAL_MODEL.TAG.ACT_FREQUENCY:
      return 'Frequency';
    case CONSTANTS.TAL_MODEL.TAG.ACT_SEVERITY:
      return 'Severity';
    case CONSTANTS.TAL_MODEL.TAG.ACT_LOSS_MULT:
      return 'Loss Cost, Multiplied';
    case CONSTANTS.TAL_MODEL.TAG.ACT_LOSS_DIRECT:
      return 'Loss Cost, Direct';
    default:
      return false;
  }
};

/* eslint-disable react/prop-types */

export default function ActuarialDownloads({
  id,
  dataModelType,
  validationCluster,
  iconSize,
  fetchEntityDl,
  originalTenant,
  role,
}) {
  const dlNameType = getNameType(dataModelType);
  const hasValidationDl = get(validationCluster, 'downloads', []).find(
    ({ name, bucket, key }) => name && bucket && key
  );
  const [isDlModalOpen, showDlModal] = useState(false);
  const handleOpenModal = useCallback(() => showDlModal(true), []);
  const handleCloseModal = useCallback(() => showDlModal(false), []);
  // const [isDelModalOpen, setIsDelModalOpen] = useState(false);
  // const [downloadName, setDownloadName] = useState(null);
  const downloads = useMemo(() => {
    const dlList = [];
    if (validationCluster && validationCluster.id && dlNameType && hasValidationDl) {
      dlList.push({
        ...hasValidationDl,
        type: 'validation',
        entityId: validationCluster.id,
      });
    }
    return dlList;
  }, [dlNameType, hasValidationDl, validationCluster]);
  return (
    <Rbac roles={[CONSTANTS.ROLE.ADMIN, CONSTANTS.ROLE.SUPER_ADMIN, CONSTANTS.ROLE.VIEWER]}>
      {CONSTANTS.SANDBOX_TENANT === originalTenant && role === CONSTANTS.ROLE.VIEWER ? (
        <Div d="flex" m={{ x: '-0.3125rem' }}>
          <Icon
            size={iconSize}
            viewBox="0 0 50 50"
            color="tabRest"
            name="Download"
            cursor="not-allowed"
            data-tip="Download Disabled"
            m={{ r: '0.3125rem' }}
          />
        </Div>
      ) : (
        <>
          {hasValidationDl ? (
            <Icon
              color="tabSelected"
              viewBox="0 0 50 50"
              name="Download"
              hoverTransform="scale(1.25)"
              size={iconSize}
              cursor="pointer"
              data-tip="Download scores"
              data-test="download"
              m={{ r: '0.3125rem' }}
              onClick={handleOpenModal}
            />
          ) : null}
          <DownloadActuarialModelDialog
            isOpen={isDlModalOpen}
            downloads={downloads}
            modelId={id}
            actions={{
              close: {
                on: handleCloseModal,
              },
              cancel: {
                on: () => {},
              },
              handlers: [
                {
                  on: fetchEntityDl,
                },
              ],
            }}
          />
        </>
      )}
    </Rbac>
  );
}
